"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultState = exports.getters = exports.mutations = void 0;
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const vuex_1 = tslib_1.__importDefault(require("vuex"));
const utils_1 = require("@/utils");
const OutputsModule_1 = require("./modules/OutputsModule");
const localEnvironment_1 = require("@/utils/localEnvironment");
const VehicleSelector_1 = require("./modules/vehicleSelector/VehicleSelector");
const VMDSModule_1 = require("@/store/modules/vmds/VMDSModule");
const FcisCalculationApiModule_1 = require("@/store/modules/fcisCalculationApi/FcisCalculationApiModule");
const DeeplinkService_1 = tslib_1.__importDefault(require("@/services/DeeplinkService"));
const FcisCalculationApi_1 = tslib_1.__importDefault(require("@/services/FcisCalculationApi"));
const logger_1 = require("@/utils/logger");
const isVans = (state) => {
    var _a, _b, _c, _d;
    const productGroup = (_c = (_b = (_a = state.VMDSModule) === null || _a === void 0 ? void 0 : _a.currentVehicle) === null || _b === void 0 ? void 0 : _b.productGroup) !== null && _c !== void 0 ? _c : '';
    if (productGroup) {
        return productGroup.toLowerCase() === 'van';
    }
    return ((_d = state.app) === null || _d === void 0 ? void 0 : _d.applicationBrand) === utils_1.APP_BRAND.VANS;
};
const defaultState = {
    app: {
        appStatus: {
            errorCode: '',
            code: utils_1.APP_STATUS.LOADING,
        },
        translations: {},
        environment: '',
        language: '',
        replaceMarket: '',
        replaceLanguage: '',
        market: '',
        locale: '',
        localeFormat: '',
        appType: '',
        applicationBrand: '',
        defaultFinancingProduct: utils_1.FINANCE_TYPE.LEASING,
        defaultCustomerType: utils_1.CUSTOMER_TYPE.PRIVATE,
        vehicle: {},
        customConfiguration: {},
        configurations: {
            calculatorURL: '',
            aemFormUrl: '',
            aemFormId: '',
            ocapiParams: {
                url: '',
                version: '',
            },
            inputs: {},
            outputs: {
                wltp: {
                    type: '',
                    items: [],
                    isEcoRatingEnabled: false,
                },
                isInsuranceAccordeonOpen: false,
                buttons: [],
            },
            formatting: {},
            modelsBlackList: [],
            vehicleMasterDataSource: {
                specificModel: '',
                multipleModels: '',
                endpoint: '',
            },
            leadAndContactFormUrl: '',
        },
        errorMessages: [],
        priceTypeShown: '',
    },
};
exports.defaultState = defaultState;
vue_1.default.use(vuex_1.default);
exports.mutations = {
    SET_INIT_DATA: (state, data) => {
        state.app = Object.assign(Object.assign({}, state.app), data);
    },
    SET_CONFIGURATIONS: (state, configData) => {
        state.app.configurations = (0, localEnvironment_1.setLocalEnvironment)(configData);
    },
    SET_TRANSLATIONS: (state, translations) => {
        state.app.translations = translations;
    },
    SET_CUSTOM_CONFIGURATION: (state, data) => {
        state.app.customConfiguration = data;
    },
    SET_CUSTOMER_TYPE: (state, data) => {
        state.app.defaultCustomerType = data;
    },
    SET_APP_STATUS: (state, { status, errorCode }) => {
        state.app.appStatus = { code: status, errorCode };
    },
    SET_ERROR_MESSAGES: (state, messages) => {
        state.app.errorMessages = messages;
    },
};
exports.getters = {
    configurations: (state) => state.app.configurations,
    customConfiguration: (state) => state.app.customConfiguration,
    localeFormat: (state) => state.app.localeFormat,
    locale: (state) => state.app.locale,
    market: (state) => state.app.market,
    outputsConfig: (state) => state.app.configurations.outputs,
    appStatus: (state) => state.app.appStatus.code,
    appErrorCode: (state) => state.app.appStatus.errorCode,
    formatting: (state) => state.app.configurations.formatting,
    appType: (state) => state.app.appType,
    isModelSelector: (state) => state.app.appType === utils_1.APP_TYPE.MODEL_SELECTOR,
    environment: (state) => state.app.environment,
    wltpItems: (state) => state.app.configurations.outputs.wltp.items || [],
    translate: (state) => (key) => {
        const translation = (0, utils_1.getDescendantProp)(key, state.app.translations);
        if (!translation) {
            logger_1.logger.info(`missing translation for ${key}`);
        }
        return translation || key;
    },
    modelsBlackList: (state) => state.app.configurations.modelsBlackList || [],
    aemFormURL: (state) => state.app.configurations.aemFormUrl,
    aemFormId: (state) => state.app.configurations.aemFormId,
    errorMessages: (state) => state.app.errorMessages,
    defaultFinancingProduct: (state) => state.app.defaultFinancingProduct,
    defaultCustomerType: (state) => state.app.defaultCustomerType,
    applicationBrand: (state) => state.app.applicationBrand,
    isEcoRatingEnabled: (state) => state.app.configurations.outputs.wltp.isEcoRatingEnabled,
    isInsuranceAccordeonOpen: (state) => state.app.configurations.outputs.isInsuranceAccordeonOpen,
    priceTypeShown: (state) => state.app.configurations.priceTypeShown,
};
exports.default = new vuex_1.default.Store({
    state: defaultState,
    mutations: exports.mutations,
    actions: {
        initialiseApplication: (_a, data_1) => tslib_1.__awaiter(void 0, [_a, data_1], void 0, function* ({ dispatch, commit }, data) {
            // Demo market should be treated differently since VMDS does not recognize
            // any of the demo markets.
            if ((0, utils_1.isDemoMarket)(data.locale)) {
                data.replaceMarket = 'DE';
                data.replaceLanguage = 'de';
            }
            // 1. Here is where everything begins!
            commit('SET_INIT_DATA', data);
            commit('SET_CUSTOM_CONFIGURATION', data.customConfiguration);
            DeeplinkService_1.default.setMarketAndLanguage(data.replaceMarket || data.market, data.replaceLanguage || data.language, data.environment);
            FcisCalculationApi_1.default.setConfig(data.replaceMarket || data.market, data.replaceLanguage || data.language, data.environment);
            // Get configuration from FCIS Configuration Service
            dispatch('getConfigurations');
        }),
        getConfigurations: (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ state, dispatch, commit }) {
            const currentEnvironment = state.app.environment || process.env.NODE_ENV;
            const prefix = (0, utils_1.getUrlPrefix)(currentEnvironment);
            //NOTE: LEAVE FOR EASY DEBUG OF CONFIG
            // const response = await fetch(
            //   `/fixtures/owdc/${state.app.market}/${state.app.locale}.json`,
            // );
            yield dispatch('updateConfigurations', null);
            try {
                const translationsResponse = yield fetch(
                // `http://localhost:3000/translations/${state.app.market}/${state.app.language}_${state.app.market}.json`,
                `https://${prefix}assets.oneweb.mercedes-benz.com/plugin/fcis/fcis-config/translations/${state.app.market}/${state.app.language}_${state.app.market}.json`);
                const translations = yield translationsResponse.json();
                commit('SET_TRANSLATIONS', translations);
                if (state.app.appType === utils_1.APP_TYPE.SIMPLE_CALCULATOR) {
                    const subBrands = state.app.vehicle.subBrands || [];
                    const engineConcept = state.app.vehicle.engineConcept;
                    if (state.app.vehicle.subBrand) {
                        subBrands.push(state.app.vehicle.subBrand);
                    }
                    // Get Data for the current Class on VMDSModule
                    yield dispatch('getSingleClass', {
                        typeId: state.app.vehicle.typeId,
                        modelSeries: state.app.vehicle.modelSeries,
                        subBrands,
                        engineConcept,
                        applicationBrand: state.app.applicationBrand,
                        market: state.app.market,
                    });
                }
                else if (state.app.appType === utils_1.APP_TYPE.MODEL_SELECTOR) {
                    yield dispatch('getMultipleClasses', {
                        typeId: state.app.vehicle.typeId,
                        applicationBrand: state.app.applicationBrand,
                        market: state.app.market,
                    });
                }
            }
            catch (error) {
                dispatch('setAppStatus', utils_1.APP_STATUS.ERROR, utils_1.ERROR.MARKET_UNAVAILABLE);
            }
        }),
        updateConfigurations: (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ state, dispatch, commit }) {
            const currentEnvironment = state.app.environment || process.env.NODE_ENV;
            const prefix = (0, utils_1.getUrlPrefix)(currentEnvironment);
            try {
                let url;
                if (isVans(state)) {
                    // url = `http://localhost:3000/v2/vans/owdc/${state.app.market}/${state.app.locale}.json`;
                    url = `https://${prefix}assets.oneweb.mercedes-benz.com/plugin/fcis/fcis-config/v2/vans/owdc/${state.app.market}/${state.app.locale}.json`;
                }
                else {
                    // url = `http://localhost:3000/v2/owdc/${state.app.market}/${state.app.locale}.json`;
                    url = `https://${prefix}assets.oneweb.mercedes-benz.com/plugin/fcis/fcis-config/v2/owdc/${state.app.market}/${state.app.locale}.json`;
                }
                const response = yield fetch(url);
                const configs = yield response.json();
                commit('SET_CONFIGURATIONS', configs);
            }
            catch (error) {
                dispatch('setAppStatus', utils_1.APP_STATUS.ERROR, utils_1.ERROR.MARKET_UNAVAILABLE);
            }
        }),
        setCustomerType({ commit }, customerType) {
            commit('SET_CUSTOMER_TYPE', customerType);
        },
        setAppStatus({ commit }, status, errorCode = null) {
            commit('SET_APP_STATUS', { status, errorCode });
        },
        cleanErrorMessages: ({ commit }) => {
            // 100 ms before removing the notification from the store in order to give
            // WB time to perform the cool animatation when removing the notification
            const TIMEOUT = 100;
            const timer = window.setTimeout(() => {
                commit('SET_ERROR_MESSAGES', []);
                window.clearTimeout(timer);
            }, TIMEOUT);
        },
        setErrorMessages: ({ commit }, payload = []) => {
            const messages = Array.isArray(payload) ? payload : [];
            commit('SET_ERROR_MESSAGES', messages);
        },
    },
    getters: exports.getters,
    modules: {
        VMDSModule: VMDSModule_1.VMDSModule,
        OutputsModule: OutputsModule_1.OutputsModule,
        VehicleSelector: VehicleSelector_1.VehicleSelector,
        FcisCalculationApiModule: FcisCalculationApiModule_1.FcisCalculationApiModule,
    },
});
